import { Component, OnInit } from '@angular/core';
import { Usuario } from '../../model/usuario';
import { UsuarioService } from '../../services/usuario.service';

import { Consorcio } from '../../model/consorcio';
import { Seguridad } from '../../model/seguridad';


@Component({
  selector: 'app-usuario-permiso',
  templateUrl: './usuario-permiso.component.html',
  styleUrls: ['./usuario-permiso.component.css']
})
export class UsuarioPermisoComponent implements OnInit {

  public query: any;
  public codigoUsuario: string;

  public pendientes: Seguridad[];
  public actuales: Seguridad[];

  public usuarios: Usuario[];


  constructor(private _usuarioService: UsuarioService) { }

  ngOnInit() {
    this.cargarUsuarios();
  }

  cargarUsuarios() {
 

    this._usuarioService.getUsuarios().subscribe(
      data => {
        this.usuarios = data;
        console.log(data);
      },
      err => {
        console.log(err._body);
      });
  }


  cargarInformacionUsuario(){
    this.cargarPendientes();
    this.cargarActuales();
  }

  cargarPendientes() {

    this.query = { "ETIQUETA": "PERMISOS_FALTANTES", "EMAIL": this.codigoUsuario, "CODIGOPERMISO": "" };


    this._usuarioService.seguridad(this.query).subscribe(
      data => {
        this.pendientes = data;
      },
      err => {
        console.log(err._body);
      });
  }


  cargarActuales() {

    this.query = { "ETIQUETA": "PERMISOS", "EMAIL": this.codigoUsuario, "CODIGOPERMISO": "" };


    this._usuarioService.seguridad(this.query).subscribe(
      data => {
        this.actuales = data;
      },
      err => {
        console.log(err._body);
      });
  }

  quitarPermiso(permiso: Seguridad){
      this.query = { "ETIQUETA": "BORRAR", "EMAIL": this.codigoUsuario, "CODIGOPERMISO": permiso.CODIGOPERMISO };


    this._usuarioService.seguridad(this.query).subscribe(
      data => {
        
        alert("Permiso eliminado con éxito");

        this.cargarPendientes();
        this.cargarActuales();


      },
      err => {
        console.log(err._body);
      });
  }

   insertarPermiso(permiso: Seguridad){
      this.query = { "ETIQUETA": "INSERTAR", "EMAIL": this.codigoUsuario, "CODIGOPERMISO": permiso.CODIGOPERMISO };


    this._usuarioService.seguridad(this.query).subscribe(
      data => {

        alert("Permiso agregado con éxito");

        this.cargarPendientes();
        this.cargarActuales();
        
      },
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/usuario-permiso/usuario-permiso.component.ts